import React, { useState, useEffect } from 'react';
import CTSUErrorBoundary from 'components/ErrorBoundary';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Fade from '@material-ui/core/Grow';
import { CTSULoadingSpinner } from 'components';
import { RenderElement } from './RenderElement';

const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute'
  }
}));

const RenderDelay = ({
  children, delayTimeInSec, elValue
}) => {
  const [delay, setDelay] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setTimeout(() => {
      setDelay(true);
    }, delayTimeInSec * 1000);
  }, [delayTimeInSec, elValue]);

  useEffect(() => {
    setTimeout(() => {
      setDelay(false);
    }, 0);
  }, [elValue]);


  return (
    <CTSUErrorBoundary>
      <RenderElement access={delay === false}>
        <CTSULoadingSpinner />
      </RenderElement>
      <Fade
        in={delay === true}
        {...(delay === true ? { timeout: 500 } : {})}
      >
        <div className={classes.wrapper}>
          {children}
        </div>
      </Fade>
    </CTSUErrorBoundary>
  );
};


export { RenderDelay };
